import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation, clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  location: null,
  error: null,
  updateManageLocationResult: null
};

const route = "modules/manage/modals/createEditManageLocation/redux/slice";

export const manageCreateEditManageLocation = createAsyncThunk(
  "manage/createEditManageLocation/createEditManageLocation",
  async (payload, { rejectWithValue }) => {
    try {
      const mutation = `
              mutation (
                  ${payload.id ? "$id: Int!," : ""}
                  $title: String!, 
                  $enabledELDRule: Boolean, 
                  $address: AddressInput, 
                  $latitude: Float, 
                  $longitude: Float, 
                  $tagIds: [Int]
              ) {
                  data: ${payload.id ? "updateLocation" : "createLocation"} (
                      ${payload.id ? "id: $id," : ""}
                      title: $title, 
                      enabledELDRule: $enabledELDRule, 
                      address: $address, 
                      latitude: $latitude, 
                      longitude: $longitude, 
                      tagIds: $tagIds
                  ) {
                      id
                  }
              }
          `;
      const response = await clientMutation(mutation, payload, endpoints.GRAPHQL_GENERAL_V2);
      return response?.data;
    } catch (exc) {
      ExceptionManager(exc, route, "manageCreateEditManageLocation");
      return rejectWithValue(exc);
    }
  }
);

const manageCreateEditManageLocationRedux = createSlice({
  name: "manage/createEditManageLocation",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE };
    },
    openModalCreateEditManageLocation(state, action) {
      state.open = true;
      state.location = action?.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageCreateEditManageLocation
    builder.addCase(manageCreateEditManageLocation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageCreateEditManageLocation.fulfilled, (state, action) => {
      state.loading = false;
      state.updateManageLocationResult = action.payload;
    });
    builder.addCase(manageCreateEditManageLocation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageCreateEditManageLocationRedux;

// Extract and export each action creator by name
export const { reset, openModalCreateEditManageLocation } = actions;

// Export the reducer, either as a default or named export
export default reducer;
